import imageOSM from '../assets/basemaps/4UMaps.png';
import imageCarto from '../assets/basemaps/CARTO Maps.png';
import imageEsriTopo from '../assets/basemaps/Esri Topografik.png';
import imageEsriUydu from '../assets/basemaps/Esri Uydu.png';
import imageEsriYol from '../assets/basemaps/Esri Yol.png';
import imageGoogleArazi from '../assets/basemaps/Google Maps Arazi.png';
import imageGoogleUydu from '../assets/basemaps/Google Maps Uydu.png';
import imageGoogleYol from '../assets/basemaps/Google Maps Yol.png';
import imageOSMArazi from '../assets/basemaps/OpenStreetMap Arazi.png';
import imageOSMYol from '../assets/basemaps/OpenStreetMap Yol.png';
import imageOpenTopo from '../assets/basemaps/OpenTopoMap Arazi.png';

const imageObj = [
  ['4UMaps', imageOSM],
  ['CARTO Maps', imageCarto],
  ['Esri Topografik', imageEsriTopo],
  ['Esri Uydu', imageEsriUydu],
  ['Esri Yol', imageEsriYol],
  ['Google Maps Arazi', imageGoogleArazi],
  ['Google Maps Uydu', imageGoogleUydu],
  ['Google Maps Yol', imageGoogleYol],
  ['OpenTopoMap Arazi', imageOSMArazi],
  ['OpenStreetMap Arazi', imageOSMYol],
  ['OpenStreetMap Yol', imageOpenTopo],
];

export default imageObj;
